<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <v-container
    class="pa-2 pb-0 d-flex flex-column"
    style="height: 100%"
  >
    <div
      :class="$vuetify.breakpoint.lgAndUp ? 'py-4' : ''"
      class="d-flex align-center"
    >
      <back-button @close-event="$emit('close')" />
      <div>
        <div class="text-h3 font-weight-bold">
          {{ $t('editShowSort') }}
        </div>

        {{ $t('dragToSort') }}
      </div>

      <v-spacer />
      <template v-if="!$vuetify.breakpoint.mdAndUp">
        <fab-button
          background="green"
          color="white"
          fab-bottom
          fab-fixed
          fab-right
          icon="mdi-content-save"
          @click-event="save"
        />
      </template>
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn
          class="amber lighten-4 black--text"
          elevation="0"
          @click="save"
        >
          <v-icon
            left
            size="20"
          >
            mdi-content-save
          </v-icon>
          {{ $t('save') }}
        </v-btn>
      </template>
    </div>

    <div
      class="mt-4 flex-grow-1"
      style="overflow-y: scroll"
    >
      <draggable
        v-if="!refreshMarker"
        v-model="realList"
        handle=".handle"
        style="display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); grid-gap: 4px;"
      >
        <v-card
          v-for="item in realList"
          :key="item[itemId]"
          class="pa-2 mb-1"
          outlined
        >
          <v-responsive
            aspect-ratio="1"
            style="position: relative"
          >
            <div
              class="d-flex align-center justify-center flex-column"
              style="height: 100%;"
            >
              <v-icon
                class="handle"
                small
              >
                mdi-drag
              </v-icon>
              <div
                class="text-body-2 text-center"
                style="max-lines: 3;overflow: hidden;height:40px;text-overflow: ellipsis;line-clamp: 2;word-break: break-all"
              >
                {{ item[itemText] }}
              </div>
            </div>
          </v-responsive>
        </v-card>
      </draggable>
    </div>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'
import FabButton from '@/views/AadenPages/components/FabButton/FabButton'

export default {
  name: 'SortFragment',
  components: {
    BackButton,
    draggable,
    FabButton
  },
  props: {
    initialList: {
      type: Array
    },
    itemText: {
      default: 'name',
      type: String
    },
    itemId: {
      default: 'id',
      type: String
    },
    itemSort: {
      default: 'sort',
      type: String
    }
  },
  data: function () {
    return {
      refreshMarker: false,
      realList: []
    }
  },
  watch: {
    realList (val) {
      setTimeout(() => {
        this.refreshMarker = true
        setTimeout(() => {
          this.refreshMarker = false
        }, 10)
      }, 20)
    },
    initialList: {
      immediate: true,
      handler (val) {
        if (this.initialList?.length) {
          this.realList = this.initialList
          console.log(this.realList, 'Real List in sort')
        }
      }

    }
  },
  methods: {
    save () {
      this.$emit('save', this.realList)
    }
  }
}
</script>

<style scoped>

</style>
